import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const externalLink: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M11-4.75v2.5q0 .925-.656 1.594A2.17 2.17 0 0 1 8.75 0h-6.5A2.2 2.2 0 0 1 .656-.656 2.2 2.2 0 0 1 0-2.25v-6.5q0-.937.656-1.594A2.2 2.2 0 0 1 2.25-11h5.5q.106 0 .172.078.076.066.078.172v.5a.26.26 0 0 1-.078.188.23.23 0 0 1-.172.062h-5.5q-.515 0-.89.375c-.243.242-.36.531-.36.875v6.5c0 .344.117.64.36.89.25.243.546.36.89.36h6.5c.344 0 .633-.117.875-.36Q10-1.733 10-2.25v-2.5q0-.106.063-.172A.26.26 0 0 1 10.25-5h.5q.106 0 .172.078.076.066.078.172m3-6.75v4a.5.5 0 0 1-.156.36.47.47 0 0 1-.344.14.44.44 0 0 1-.344-.156l-1.375-1.375-5.093 5.094a.25.25 0 0 1-.188.078.23.23 0 0 1-.172-.078l-.89-.891a.23.23 0 0 1-.079-.172q-.002-.106.079-.187l5.093-5.094-1.375-1.375A.44.44 0 0 1 9-11.5q0-.201.14-.344A.5.5 0 0 1 9.5-12h4c.133 0 .25.055.344.156.101.094.156.211.156.344m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "12",
    width: "14",
  }
};
